var _defs, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "a",
    width: 16,
    height: 27,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAbCAMAAABC6v+QAAAAAXNSR0IB2cksfwAAAJ9QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAt5M+RAAAADV0Uk5TABZ3wfB28/9yBqSheHAQ79CT0nOcA7/PzOhn+C832KjUKdMT+vuwOEC8kA7q6w1j0SL0IWBC46GIAAAAxUlEQVR4nF1Q5xqCMBCLiFRUQIXKUhH3FpX3fzavg2V+3CX52lsAoWf0TbM/6EHDsJiENZTSHrEaY5uMCWvBAVxPkOlsNhfZc+GLHHD6GgjmY0Ex5KIYj4guEFNMVLeEaIyU4lIZK6KpNFovUqwpRqpGSHSNrNslg8P0HBs9Wc46yIFtW2+plvO3C3b7Rh9c0e7YGJmc59QYZzXhpdIXfcL8oCvk1VGvyrhWGre70I9nbeDFmp0leMFYwVsG3tbniw7KUpMfFbwPPCjWKHkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22 42.5C10.7 42.5 1.5 33.3 1.5 22S10.7 1.5 22 1.5 42.5 10.7 42.5 22 33.3 42.5 22 42.5z",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 3
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 14,
    y: 8,
    href: "#a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.760bd7021f60e5a8d5b0406d1e5dbec8.svg";
export { ForwardRef as ReactComponent };